import React, { Component, Fragment } from 'react';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import { Select } from 'antd';
import { getPanelMaxWidth, getPanelMaxHeight } from '@/services/helper/panelSizeHelper';
import projectDesigns from '@/services/helper/projectDesigns';
import { LAYOUT } from '../../../constants/designType';
import { splitArrayToArrays } from '../../../services/helper/arrayHelper';
import { AC } from '../../../constants/treeConstants';
import { IMPEDANCE_PCB } from '../../../services/Cascade/constants';

class SwitchPcbPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxWidth: 800,
      maxHeight: 1000,
      pcbId: "",
      pcbList: [],
    };
    this.dialogRoot = document.getElementById('root');
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxWidth: getPanelMaxWidth(offset, 800),
      maxHeight: getPanelMaxHeight(offset, 1000),
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getLayoutList();
  }

  closeModal = () => {
    const { pcbId } = this.state;
    if (pcbId) {
      this.props.switchPcb(pcbId)
    }
    this.props.closeSwitchPanel(false)
  }

  pcbSelect = (pcbId) => {
    this.setState({
      pcbId
    })
  }

  getLayoutList = () => {
    const { projectId, designId, type } = this.props;
    const packageList = projectDesigns.getAvailablePackages(projectId);
    const pcbList = projectDesigns.getAvailablePCBs(projectId);
    const preLayoutList = projectDesigns.getAvailablePreLayouts(projectId).filter(design => design && design.content && (!design.content.electric || design.content.electric === AC));
    const preLayoutRule = (item) => {
      return item.type === LAYOUT ? true : false;
    }
    const { trueArray: preLayoutPCBs, falseArray: preLayoutPackages } = splitArrayToArrays({ array: preLayoutList, rule: preLayoutRule })
    this.setState({
      pcbList: type === IMPEDANCE_PCB ? [...pcbList, ...preLayoutPCBs] : [...packageList, ...preLayoutPackages],
      pcbId: designId
    })
  }

  timeResize = () => {
    setTimeout(() => {
      this.resize()
    }, 1000)
  }

  pcbSelectRender = () => {
    const { pcbId, pcbList } = this.state;
    const { type, designIds } = this.props
    return (
      <div className="cascade-switch-pcb-content">
        <span className="font-bold cascade-setup-title-color-only">{`${type === IMPEDANCE_PCB ? 'PCB' : 'Package'}`}</span>
        <Select
          value={pcbId}
          onChange={this.pcbSelect}
          getPopupContainer={(() => document.getElementById('root'))}
          showSearch={true}
          className="pcb-select"
          popupClassName="aurora-select-dropdown"
          options={pcbList.map(option => ({
            value: option.id,
            label: option.name,
            title: option.name,
            disabled: designIds.includes(option.id)
          }))}
        />
      </div>
    );
  }

  render() {
    const { maxHeight, maxWidth } = this.state
    const { type } = this.props
    const content = (
      <Fragment>
        <Panel
          className='cascade-add-pcb-panel'
          title={`Switch ${type === IMPEDANCE_PCB ? 'PCB' : 'Package'}`}
          onCancel={this.closeModal}
          zIndex={2000}
          width={500}
          maxHeight={maxHeight}
          maxWidth={maxWidth}
          position='panel-center-left'
          draggable
          minHeight={300}
          minWidth={200}
          resizeEnd={this.timeResize}
        >
          {this.pcbSelectRender()}
        </Panel>
        <div id="cascade-add-connection-dialog"></div>
      </Fragment>
    )
    return createPortal(content, this.dialogRoot);
  }
};

export default SwitchPcbPanel;
